import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { MyPromise } from '../interceptors/myPromise.service';

const COURSESURL = `${environment.baseEndpoint}/courses`;

@Injectable({
  providedIn: 'root',
})
export class CoursesService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise,
  ) { }

  getCourses() {
    return this.myPromise.to(this.http.get(`${COURSESURL}/`));
  }

  getCoursesByRole(role: string) {
    return this.myPromise.to(this.http.get(`${COURSESURL}/role?role=${role}`));
  }
}
